export const TOOL_MAIN_OPTIONS = [
  // { key: 0, value: "تنظیمات", link:"/project-setting"},
  { key: 1, value: "منابع مصرفی", link: "/construction-component" },
  { key: 2, value: "فعالیت‌ها", link: "/construction-phase" },
  { key: 3, value: "مخاطبین", link: "/contact" },
  { key: 4, value: "حساب‌های بانکی", link: "/bank-account" },
  { key: 5, value: "صندوق", link: "/wallet" },
  { key: 6, value: "ابزار و ماشین آلات", link: "/tools" }
];
export const TOOL_HEADER_1_OPTIONS = [
  { key: 1, value: "حساب کاربری", link: "/user-account-setting"},
  { key: 2, value: "مدیریت پروژه‌ها", link: "/projects-management" },
];
export const TOOL_HEADER_2_OPTIONS = [
  { key: 1, value: "تنظیمات پروژه", link: "/project-setting" },
  {
    key: 2,
    value: "مدیریت اعضای پروژه",
    link: "/project-member-management",
  }
];
export const TOOL_FOOTER_OPTIONS = [
  { key: 1, value: "تهیه نسخه پشتیبان", link: "/backup" },
  { key: 2, value: "آرشیو دانلودها", link: "/files" }
];
